import { ComponentType } from '@angular/cdk/portal';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
    ChangeDetectorRef,
    Component,
    computed,
    effect,
    ElementRef,
    EventEmitter,
    HostListener,
    inject,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
    Renderer2,
    signal,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
    NavigationEnd,
    NavigationSkipped,
    NavigationStart,
    Router,
} from '@angular/router';
import { BabylonGlobalItem } from '@ctt-babylon/lib/interfaces/babylon-global-item.interface';
import { BabylonImageI } from '@ctt-babylon/lib/interfaces/babylon-image.interface';
import {
    BabylonBookingWidgetComponent,
    BabylonBreadcrumbComponent,
    BabylonBreadcrumbV2Component,
    BabylonButtonI,
    BabylonColorPickerComponent,
    BabylonEngineComponent,
    BabylonEngineI,
    BabylonEngineModalComponent,
    BabylonEngineModalI,
    BabylonFloatingButtonsComponent,
    BabylonFoC3ImgTxtComponent,
    BabylonFoC3TxtSvgCtaComponent,
    BabylonFoLisC4TxtComponent,
    BabylonFooterContactComponent,
    BabylonFooterContactI,
    BabylonFooterLinksComponent,
    BabylonFooterLinksI,
    BabylonFooterLogosComponent,
    BabylonFooterLogosI,
    BabylonGlobal,
    BabylonGlobalModalI,
    BabylonHeaderBookShowComponent,
    BabylonHeaderBookShowI,
    BabylonHeaderClearComponent,
    BabylonHeaderClearI,
    BabylonHeaderClearV2Component,
    BabylonHeaderGLobalI,
    BabylonHeaderMenuCenterComponent,
    BabylonHeaderMenuCenterI,
    BabylonHeaderMenuLogoCenterComponent,
    BabylonHeaderMenuLogoCenterI,
    BabylonHeaderMenuShowComponent,
    BabylonHeaderMenuShowI,
    BabylonHeaderMobileComponent,
    BabylonHeaderMobileI,
    BabylonHeMeSvgTextCtaMotComponent,
    BabylonHeSvgListComponent,
    BabylonLanguageModalComponent,
    BabylonLanguageModalI,
    BabylonLanguageModalItem,
    BabylonLanguageModalV2Component,
    BabylonLanguageModalV3Component,
    BabylonLisLinkCleansComponent,
    BabylonModalMultipleMotorsComponent,
    BabylonModalMultipleMotorsI,
    BabylonModalService,
    BabylonModC2ImgTxtCtaComponent,
    BabylonNewsletterComponent,
    BabylonNewsletterI,
    BabylonNewsletterModalV2Component,
    BabylonOfferPopupV3Component,
    BabylonStaticFooterComponent,
    BabylonStaticFooterI,
    BabylonStaticFooterV2Component,
    BabylonStaticFooterV2I,
    BabylonStaticFooterV3Component,
    BabylonStaticFooterV4Component,
    BabylonSubmenuHotelComponent,
    BabylonTextInfoI,
    BabylonTopSliderComponent,
    BabylonTopSliderThumbsComponent,
    BabylonTopSliderVideoComponent,
    BabylonTopSliderVideoV2Component,
    BodyComponent,
    C4FoLinkSvgComponent,
    C4MeTxtSvgCtaComponent,
    FoC0SvgLinkComponent,
    FoC2ImgTxtComponent,
    FoC3TxtIcoV2Component,
    FoC4TxtSvgComponent,
    LogoType,
    ModuloMenuHomeComponent,
    ScreenSizerService,
} from 'ctt-babylon';
import { catchError, EMPTY, Subscription, switchMap, tap } from 'rxjs';
import { widgetConfig } from '../../config/widget-engine-config';
import { DynamicHeaderPageDirective } from '../../directives/dynamicHeaderPage/dynamic-header-page.directive';
import { WidgetMotorMoveToHeaderDirective } from '../../directives/widget-engine/directives/widget-motor-swap.directive';
import { environment } from '../../environments/environment';
import { BtnBookPipe } from '../../pipes/btn-book.pipe';
import { ApiService } from '../../services/api/api.service';
import {
    BabylonHeadersType,
    LayoutService,
} from '../../services/layout/layout.service';
import { FragmentScrollService } from '../../services/page/fragment-scroll.service';
import { RoutesService } from '../../services/routes/routes.service';
import { TEMPLATES } from '../../services/routes/templates';
import { SiteConfigService } from '../../services/site-config/site-config.service';
import { ColorThemeUtils } from '../../utils/color-theme.utils';

const THEME_CLASSES = ['red', 'blue', 'green'] as const;

@Component({
    selector: 'app-layout',
    standalone: true,
    imports: [
        CommonModule,
        BabylonHeaderBookShowComponent,
        BabylonStaticFooterComponent,
        BabylonStaticFooterV2Component,
        BabylonFooterLogosComponent,
        BabylonFooterLinksComponent,
        BabylonFooterContactComponent,
        BabylonHeaderClearComponent,
        BabylonHeaderMenuCenterComponent,
        BabylonHeaderMenuShowComponent,
        BabylonHeaderMenuLogoCenterComponent,
        BabylonEngineComponent,
        BabylonSubmenuHotelComponent,
        BabylonHeaderMobileComponent,
        BabylonTopSliderComponent,
        BabylonTopSliderThumbsComponent,
        BabylonTopSliderVideoComponent,
        BabylonBreadcrumbComponent,
        DynamicHeaderPageDirective,
        BabylonColorPickerComponent,
        BabylonFoC3TxtSvgCtaComponent,
        BtnBookPipe,
        BabylonFloatingButtonsComponent,
        C4MeTxtSvgCtaComponent,
        C4FoLinkSvgComponent,
        BabylonHeSvgListComponent,
        BabylonHeaderClearV2Component,
        BabylonTopSliderVideoV2Component,
        BabylonStaticFooterV3Component,
        BabylonFoLisC4TxtComponent,
        BabylonFoC3ImgTxtComponent,
        BabylonBookingWidgetComponent,
        BabylonBreadcrumbV2Component,
        WidgetMotorMoveToHeaderDirective,
        FoC4TxtSvgComponent,
        ModuloMenuHomeComponent,
        FoC0SvgLinkComponent,
        FoC2ImgTxtComponent,
        BabylonHeMeSvgTextCtaMotComponent,
        BabylonStaticFooterV4Component,
        BabylonLisLinkCleansComponent,
        FoC3TxtIcoV2Component,
    ],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss',
    /*  changeDetection: ChangeDetectionStrategy.OnPush, */
})
export class LayoutComponent implements OnInit, OnDestroy {
    @ViewChild('footer', { read: ElementRef }) footerEl!: ElementRef;
    @ViewChild('colorPickerRef')
    colorPickerComponent!: BabylonColorPickerComponent;

    @ViewChild('staticfooter', { static: true })
    staticfooter!: TemplateRef<any>;

    @ViewChild('staticfooterv2', { static: true })
    staticfooterv2!: TemplateRef<any>;

    @ViewChild('staticfooterv3', { static: true })
    staticfooterv3!: TemplateRef<any>;

    @ViewChild('staticfooterv4', { static: true })
    staticfooterv4!: TemplateRef<any>;

    @ViewChild('folisc4txt', { static: true })
    folisc4txt!: TemplateRef<any>;

    @ViewChild('foc3txtsvgcta', { static: true })
    foc3txtsvgcta!: TemplateRef<any>;

    @ViewChild('foc0svglink', { static: true })
    foc0svglink!: TemplateRef<any>;

    @ViewChild('c4folinksvg', { static: true })
    c4folinksvg!: TemplateRef<any>;

    @ViewChild('footerContact', { static: true })
    footerContact!: TemplateRef<any>;

    @ViewChild('footerlinks', { static: true })
    footerlinks!: TemplateRef<any>;

    @ViewChild('foc3txticov2', { static: true })
    foc3txticov2!: TemplateRef<any>;

    @ViewChild('footerlogos', { static: true })
    footerlogos!: TemplateRef<any>;

    @ViewChild('folislinks', { static: true })
    folislinks!: TemplateRef<any>;

    @ViewChild('headerClearV2', { static: true })
    headerClearV2!: TemplateRef<any>;

    public isBookingEngineEnabled: boolean = false;
    public isBookingEngineWidget: boolean = false;
    public isBookingEngineWidgetDynamic: boolean = false;

    widgetConfig = widgetConfig;

    private openedNewsletterV2 = false;
    private readonly NEWSLETTER_V2_SS_KEY = 'newsletterV2';
    private _newsletterDataV2?: BabylonGlobalModalI;

    private readonly OFFER_V3_SS_KEY = 'offerPopupV3_opened';
    private _offerPopupV3Data?: BabylonGlobalModalI;

    // --- timers/subscriptions (para evitar acumulaciones) ---
    private routerSub?: Subscription;
    private viewControlTimeoutId?: number;
    private footersTimeoutId?: number;

    @Input()
    set newsletterDataV2(value: BabylonGlobalModalI | undefined) {
        this._newsletterDataV2 = value;
        this.tryAutoOpenNewsletterV2();
    }

    get newsletterDataV2(): BabylonGlobalModalI | undefined {
        return this._newsletterDataV2;
    }

    @Input()
    set offerPopupV3Data(value: BabylonGlobalModalI | undefined) {
        this._offerPopupV3Data = value;
        this.tryAutoOpenOfferV3();
    }

    loadingPageData: boolean = false;
    private hasCompletedFirstNavigation = false;

    @Input() headerData?: BabylonHeaderBookShowI;
    @Input() headerData2?: BabylonHeaderClearI;
    @Input() headerData3?: BabylonHeaderMenuCenterI;
    @Input() headerData4?: BabylonHeaderMenuShowI;
    @Input() headerData5?: BabylonHeaderMenuLogoCenterI;
    @Input() headerData6?: BabylonHeaderMobileI;
    @Input() headerData7?: BabylonHeaderGLobalI;
    @Input() languagesData?: BabylonLanguageModalI;
    @Input() newsletterData?: BabylonNewsletterI;
    @Input() modalMultipleMotorsData?: BabylonModalMultipleMotorsI;
    @Input() selectorModal?: {
        texts: BabylonTextInfoI;
        items: BabylonGlobalItem[];
    };
    @Input() globalInfo?: BabylonGlobal;

    minSizeMobileHeader = environment.minSizeMobileHeader;

    $footer = signal<
        BodyComponent<BabylonStaticFooterI | BabylonStaticFooterV2I> | undefined
    >(undefined);

    $foC0SvgLink = signal<
        BodyComponent<BabylonStaticFooterI | BabylonStaticFooterV2I> | undefined
    >(undefined);

    $footerLogos = signal<BodyComponent<BabylonFooterLogosI> | undefined>(
        undefined
    );

    $foc3txticov2 = signal<
        BodyComponent<BabylonStaticFooterI | BabylonStaticFooterV2I> | undefined
    >(undefined);

    $folislinks = signal<BodyComponent<BabylonFooterLinksI> | undefined>(
        undefined
    );

    $footerLinks = signal<BodyComponent<BabylonFooterLinksI> | undefined>(
        undefined
    );

    $foc3imgtxt = signal<BodyComponent<any> | undefined>(undefined);

    $footerContact = signal<BodyComponent<BabylonFooterContactI> | undefined>(
        undefined
    );

    breadcrumbs$ = computed(() => {
        return this.layoutSvc.breadcrumbs();
    });

    breadcrumbsv2$ = computed(() => {
        return this.layoutSvc.breadcrumbsv2();
    });

    submenu$ = computed(() => {
        const submenuR = this.layoutSvc.submenu();
        let themeClass: (typeof THEME_CLASSES)[number] | null = null;
        if (!submenuR) {
            themeClass = 'red';
            ColorThemeUtils.applyBodyThemeClass(themeClass, THEME_CLASSES);
            return;
        }

        const primary = submenuR.styles?.primary;

        const family = primary
            ? ColorThemeUtils.getColorFamily(primary)
            : 'unknown';

        if (family === 'blue' || family === 'purple') {
            themeClass = 'blue';
        } else if (
            family === 'red' ||
            family === 'orange' ||
            family === 'pink'
        ) {
            themeClass = 'red';
        } else if (family === 'green' || family === 'cyan') {
            themeClass = 'green';
        } else {
            themeClass = 'red';
        }

        ColorThemeUtils.applyBodyThemeClass(themeClass, THEME_CLASSES);

        return this.layoutSvc.submenu();
    });

    hotelType$ = computed(() => {
        return this.layoutSvc.hotelType();
    });

    hotelCategory$ = computed(() => {
        return this.layoutSvc.hotelCategory();
    });

    ticker$ = computed(() => {
        return this.layoutSvc.ticker();
    });

    topSlider$ = computed(() => {
        return this.layoutSvc.topSlider();
    });

    roomsModal$ = computed(() => {
        return this.layoutSvc.roomsModal();
    });

    get loadFooter(): boolean {
        return this.layoutSvc.loadFooterInstant;
    }

    get loadHeaders(): boolean {
        return this.layoutSvc.loadHeadersInstant;
    }

    get advantagesUp(): boolean {
        return this.layoutSvc.advantagesUpInstant;
    }

    get pageType(): boolean {
        return this.layoutSvc.pageTypeInstant;
    }

    get engine(): BabylonEngineI | undefined {
        return this.layoutSvc.engineDataInstant;
    }

    // Devuelve un objeto con claves del tipo `LogoType` y valores de tipo `BabylonImageI`,
    // adaptando la estructura desde un array o un objeto según el formato recibido en la configuración.
    get logos(): Record<LogoType, BabylonImageI | undefined> {
        const raw = this.siteSvc.webConfigInstant?.logos;

        const buildImage = (
            url: string | undefined
        ): BabylonImageI | undefined =>
            url ? { src: url, alt: '' } : undefined;

        const result = {} as Record<LogoType, BabylonImageI | undefined>;

        for (const key of Object.values(LogoType)) {
            if (
                typeof raw === 'object' &&
                !Array.isArray(raw) &&
                raw !== null
            ) {
                result[key] = buildImage((raw as any)[key]);
            } else if (Array.isArray(raw)) {
                const index = Object.values(LogoType).indexOf(key);
                result[key] = buildImage(raw[index]);
            } else {
                result[key] = undefined;
            }
        }

        return result;
    }

    get minMobileHeader(): boolean {
        if (isPlatformBrowser(this.platformId)) {
            switch (this.minSizeMobileHeader) {
                case 768:
                    return this.screenSizer.minMediumTablet();
                case 1024:
                    return this.screenSizer.minFullTablet();
                default:
                    return this.screenSizer.minMediumTablet();
            }
        }

        return true;
    }

    get isDynamicHeader(): boolean {
        return this.layoutSvc.dynamicHeaderInstant;
    }

    public isPageDataLoaded(): boolean {
        const isBrowser = isPlatformBrowser(this.platformId);

        return computed(() => {
            const hasSomeHeader = [
                this.headerData,
                this.headerData2,
                this.headerData3,
                this.headerData4,
                this.headerData5,
                this.headerData6,
            ].some((h) => h !== undefined);

            return isBrowser
                ? this.layoutSvc.pageDataLoaded() &&
                      this.engine !== undefined &&
                      hasSomeHeader
                : this.layoutSvc.pageDataLoaded();
        })();
    }

    linkLogo: BabylonButtonI = {};
    currentUrl: string = '';
    lastPath = '';
    headerVersion: BabylonHeadersType = 'headerClearEngineShow'; //headerBookShow - headerClear/headerClearEngineShow - headerMenuCenter - headerMenuShow/headerMenuShowEngineShow - headerCenterBookShow - C4MeTxtSvgCtaComponent - BabylonHeSvgListComponent -headerClearV2
    comingSoonUrl: string = TEMPLATES.COMINGSOON;
    inComingSoon: boolean = false;
    mostrarColorPicker: boolean = false;
    openInNewWindow: boolean = environment.openInNewWindow;
    multipleMotorsModal: boolean = environment.multipleMotorsModal;
    engine_extern: boolean = environment.booking_engine_extern;
    booking_engine_top_enabled: boolean =
        environment.booking_engine_top_enabled;
    booking_button_engine_enabled: boolean =
        environment.booking_button_engine_enabled;

    linkHome: string = '';

    private readonly frag = inject(FragmentScrollService);

    private document = inject(DOCUMENT);
    public hasBreadcrumbsTop = signal<boolean>(false);
    private readonly cdr = inject(ChangeDetectorRef);

    constructor(
        private readonly dialog: MatDialog,
        private readonly layoutSvc: LayoutService,
        private readonly router: Router,
        private readonly siteSvc: SiteConfigService,
        private readonly routesSvc: RoutesService,
        private readonly screenSizer: ScreenSizerService,
        private readonly apiSvc: ApiService,
        private readonly renderer: Renderer2,
        private readonly alert: MatSnackBar,
        private readonly modalSvc: BabylonModalService,
        @Inject(PLATFORM_ID) private readonly platformId: Object
    ) {
        effect(
            () => {
                if (this.layoutSvc.footer()) {
                    const data = this.layoutSvc.footerInstant;
                    this.$footer.set(data);
                }
                if (this.layoutSvc.foC0SvgLink()) {
                    const data = this.layoutSvc.foC0SvgLinkInstant;
                    this.$foC0SvgLink.set(data);
                }
                if (this.layoutSvc.footerLogos()) {
                    const data = this.layoutSvc.footerLogosDataInstant;
                    this.$footerLogos.set(data);
                }
                if (this.layoutSvc.footerLinks()) {
                    const data = this.layoutSvc.footerLinksDataInstant;
                    this.$footerLinks.set(data);
                }
                if (this.layoutSvc.foc3imgtxt()) {
                    const data = this.layoutSvc.foc3imgtxtDataInstant;
                    this.$foc3imgtxt.set(data);
                }
                if (this.layoutSvc.footerContact()) {
                    const data = this.layoutSvc.footerContactDataInstant;
                    this.$footerContact.set(data);
                }
                if (this.layoutSvc.folislinks()) {
                    const data = this.layoutSvc.folislinksDataInstant;
                    this.$folislinks.set(data);
                }
                if (this.layoutSvc.foC3TxtIcoV2()) {
                    const data = this.layoutSvc.foC3TxtIcoV2DataInstant;
                    this.$foc3txticov2.set(data);
                }
            },
            { allowSignalWrites: true }
        );

        effect(
            () => {
                const isLoaded = this.layoutSvc.pageDataLoaded();

                if (isLoaded && isPlatformBrowser(this.platformId)) {
                    setTimeout(() => {
                        this.checkIfComponentExists();
                    }, 100);
                } else if (!isLoaded) {
                    this.hasBreadcrumbsTop.set(false);
                }
            },
            { allowSignalWrites: true }
        );

        this.layoutSvc.setSelectedHeader(this.headerVersion);
    }

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            const params = new URLSearchParams(window.location.search);
            if (params.has('activar_panel') && this.colorPickerComponent) {
                const { userPanel, passPanel } = environment;
                this.colorPickerComponent.setCredentials(userPanel, passPanel);
            }
        }
    }

    // En layout.component.ts reemplaza el HostListener
    @HostListener('document:visibilitychange', ['$event'])
    onVisibilityChange() {
        if (document.visibilityState === 'visible') {
            // 1. Forzamos un resize para que screenSizer detecte el tamaño real de escritorio
            window.dispatchEvent(new Event('resize'));

            this.cdr.detectChanges(); // Forzamos el check de Angular

            // En lugar de disparar scroll, reiniciamos el control de la vista
            // pasándole un delay 0 para que actúe inmediatamente.
            this.ViewControl(true, 0);
        }
    }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            const params = new URLSearchParams(window.location.search);
            this.mostrarColorPicker = params.has('activar_panel');
        }

        this.isBookingEngineEnabled = environment.booking_engine_enabled;

        this.isBookingEngineWidget = environment.booking_engine_widget;
        this.isBookingEngineWidgetDynamic =
            environment.booking_engine_widget_dynamic;

        if (!isPlatformBrowser(this.platformId)) {
            // En SSR no mostramos overlay para que el HTML sea visible (SEO/Lighthouse)
            this.loadingPageData = false;
        }

        if (isPlatformBrowser(this.platformId)) {
            this.currentUrl = this.router.url;
            this.lastPath = this.stripQueryAndHash(this.router.url);
            this.newFootersController(true);

            this.linkHome = this.routesSvc.getHomeUrlByLanguage();

            this.routerSub = this.router.events.subscribe((event) => {
                if (event instanceof NavigationStart) {
                    // OJO: NavigationStart NO tiene urlAfterRedirects
                    // Evita overlay en la navegación inicial del arranque
                    if (this.hasCompletedFirstNavigation) {
                        this.loadingPageData = true;
                    }
                    this.newFootersController(false);
                    this.InitHeaderControl();
                }

                if (event instanceof NavigationEnd) {
                    const urlFinal = event.urlAfterRedirects || event.url || '';
                    const newTree = this.router.parseUrl(urlFinal);
                    const hasQuery =
                        Object.keys(newTree.queryParams || {}).length > 0;

                    const newPath = urlFinal.split('?')[0];

                    this.linkHome = this.routesSvc.getHomeUrlByLanguage();
                    this.hasCompletedFirstNavigation = true;

                    // Guardamos el path anterior para comparar (aquí estaba tu bug)
                    const oldPath = this.lastPath;

                    // Guardamos también la query anterior para detectar cambios reales
                    const oldTree = this.router.parseUrl(this.currentUrl || '');
                    const oldQuery = oldTree.queryParams || {};
                    const newQuery = newTree.queryParams || {};
                    const queryChanged =
                        JSON.stringify(oldQuery) !== JSON.stringify(newQuery);

                    const oldFrag = oldTree.fragment ?? '';
                    const newFrag = newTree.fragment ?? '';
                    const fragmentChanged =
                        oldFrag !== '' && newFrag !== ''
                            ? oldFrag !== newFrag
                            : false;

                    this.currentUrl = urlFinal;
                    this.lastPath = newPath;

                    const normalizedComingSoonUrl = this.comingSoonUrl
                        .replace(/\s+/g, '')
                        .toLowerCase();
                    this.inComingSoon = this.currentUrl
                        .toLowerCase()
                        .includes(normalizedComingSoonUrl);

                    const samePageOnlyQueryChanged =
                        newPath === oldPath && queryChanged;

                    // Si solo cambió la query en la misma página -> NO esperar 2000ms
                    if (samePageOnlyQueryChanged || fragmentChanged) {
                        this.ViewControl(
                            this.headerVersion !== 'headerBookShow',
                            0
                        );
                        if (fragmentChanged) {
                            this.frag.checkAndScroll();
                        }
                        return;
                    }

                    this.layoutSvc.setLoadFooter(false);
                    this.layoutSvc.setLoadHeaders(false);

                    // Si la navegación trae query params, no esperes 2000 al final
                    this.ViewControl(
                        this.headerVersion !== 'headerBookShow',
                        hasQuery ? 0 : 2000
                    );
                }

                if (event instanceof NavigationSkipped) {
                    this.ViewControl();
                }
            });

            this.ViewControl();
        }
    }

    ngOnDestroy(): void {
        this.routerSub?.unsubscribe();

        if (this.viewControlTimeoutId) {
            window.clearTimeout(this.viewControlTimeoutId);
            this.viewControlTimeoutId = undefined;
        }

        if (this.footersTimeoutId) {
            window.clearTimeout(this.footersTimeoutId);
            this.footersTimeoutId = undefined;
        }
    }

    private stripQueryAndHash(url: string): string {
        return (url || '').split('#')[0].split('?')[0];
    }

    InitHeaderControl() {
        /* setTimeout(() => {
            if (
                this.headerVersion != 'C4MeTxtSvgCtaComponent' &&
                this.headerVersion != 'HeSvgListComponent' &&
                this.headerVersion != 'headerClearV2' &&
                this.headerVersion != 'ModuloMenuHomeComponent' &&
                this.headerVersion != 'BabylonHeMeSvgTextCtaMot'
            ) {
                const header_desktop = document.getElementsByClassName(
                    'header-desktop-container'
                );
                Array.from(header_desktop).forEach((el: Element) => {
                    (el as HTMLElement).style.opacity = '0';
                });
            }
        }, 50); */
    }

    ViewControl(init: boolean = true, delayMs: number = 2000) {
        const engineElements = document.querySelectorAll(
            'lib-babylon-engine'
        ) as NodeListOf<HTMLElement>;
        engineElements.forEach((el) => (el.style.display = 'none'));

        if (init) {
            setTimeout(() => {
                engineElements.forEach((el) => (el.style.display = 'block'));
            }, 0);
        }

        // Delete clase no_scroll when on modal menu click to link
        if (document.body.classList.contains('no_scroll')) {
            document.body.classList.toggle('no_scroll');
            document.body.style.overflow = '';
        }

        // Evita acumular timeouts
        if (this.viewControlTimeoutId) {
            window.clearTimeout(this.viewControlTimeoutId);
        }

        this.viewControlTimeoutId = window.setTimeout(() => {
            this.newFootersController(true);
            this.viewControlTimeoutId = undefined;
        }, delayMs);
    }

    newFootersController(isStart = false): void {
        if (!isPlatformBrowser(this.platformId)) return;

        // Si estamos arrancando, corta y no dispares timeouts
        if (isStart) {
            this.loadingPageData = false;
            return;
        }

        // Evita acumular timeouts
        if (this.footersTimeoutId) {
            window.clearTimeout(this.footersTimeoutId);
        }

        this.footersTimeoutId = window.setTimeout(() => {
            this.loadingPageData = false;
            this.footersTimeoutId = undefined;
        }, 2000);
    }

    openEngineModal(): void {
        const dialogRef = this.dialog.open(BabylonEngineModalComponent, {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            hasBackdrop: true,
        });

        const closeEvent = new EventEmitter();

        closeEvent.subscribe(() => {
            dialogRef.close();
        });
        const data = this.layoutSvc.engineDataInstant as BabylonEngineI;

        dialogRef.componentInstance.onlyAdults = data.onlyAdults;
        dialogRef.componentInstance.datepickerData = data.datepickerData;
        dialogRef.componentInstance.guestsInput = data.guestsInput;
        dialogRef.componentInstance.promoInput = data.promoInput;
        dialogRef.componentInstance.guests = data.guests;
        dialogRef.componentInstance.button = data.button;
        dialogRef.componentInstance.title = (data as BabylonEngineModalI).title;
        dialogRef.componentInstance.subtitle = (
            data as BabylonEngineModalI
        ).subtitle;
        dialogRef.componentInstance.hotelsInput = (
            data as BabylonEngineModalI
        ).hotelsInput;
        dialogRef.componentInstance.hotels = (
            data as BabylonEngineModalI
        ).hotels;
        dialogRef.componentInstance.openInNewWindow = this.openInNewWindow;
        // dialogRef.componentInstance.multipleMotorsModal = this.multipleMotorsModal;
        dialogRef.componentInstance.close = closeEvent;
    }

    openLanguagesModal(version: 1 | 2 | 3 | null | undefined): void {
        if (!version)
            this.openLangModalbyVersion(BabylonLanguageModalComponent);
        switch (version) {
            case 1:
                this.openLangModalbyVersion(BabylonLanguageModalComponent);
                break;

            case 2:
                this.openLangModalbyVersion(BabylonLanguageModalV2Component);
                break;

            case 3:
                this.openLangModalbyVersion(BabylonLanguageModalV3Component);
                break;
            default:
                this.openLangModalbyVersion(BabylonLanguageModalComponent);
                break;
        }
    }

    openLangModalbyVersion<T>(modal: ComponentType<T>): void {
        const dialogRef = this.dialog.open<T>(modal, {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            hasBackdrop: true,
        });

        const selectecEvent = new EventEmitter<BabylonLanguageModalItem>();

        selectecEvent.subscribe((lang) => {
            this.updateLanguage(lang);
        });

        const instance = dialogRef.componentInstance as
            BabylonLanguageModalComponent | BabylonLanguageModalV3Component;

        instance.title = this.languagesData?.title;
        instance.subtitle = this.languagesData?.subtitle;
        instance.items = this.languagesData?.items;
        instance.selected = this.languagesData?.selected;

        instance.languageSelect = selectecEvent;
    }

    updateLanguage(lang: BabylonLanguageModalItem): void {
        if (isPlatformBrowser(this.platformId)) {
            this.loadingPageData = true;
            const selectedLanguage =
                this.siteSvc.webConfigInstant?.languages.find(
                    (language: any) => Number(language.id) === Number(lang.id)
                );

            if (selectedLanguage) {
                this.siteSvc.changeLanguage(selectedLanguage);
                localStorage.setItem(
                    'language',
                    JSON.stringify(this.siteSvc.selectedLanguageInstant)
                );

                const newUrl = this.routesSvc.switchUrlDiferentLanguage(
                    this.router.url
                );

                if (newUrl) window.location.assign(newUrl);
                /* this.router.navigateByUrl(newUrl ?? '');

                setTimeout(() => {
                    location.reload();
                }, 200); */
            }
        }
    }

    openNewsletterModal(): void {
        if (isPlatformBrowser(this.platformId)) {
            const dialogRef = this.dialog.open(BabylonNewsletterComponent, {
                width: this.screenSizer.minMediumTablet() ? '65%' : '95vw',
                height: this.screenSizer.minMediumTablet() ? '80%' : '85vh',
                maxHeight: this.screenSizer.minMediumTablet()
                    ? '714px'
                    : '100vh',
                maxWidth: this.screenSizer.minMediumTablet()
                    ? '1000px'
                    : '100vw',
                hasBackdrop: true,
                panelClass: 'newsletter',
            });
            const submit = new EventEmitter<any>();

            submit
                .pipe(
                    switchMap((email) => {
                        return this.apiSvc
                            .postNewsletterForm({
                                siteId: environment.siteId,
                                consultTypeId: 9,
                                languageId:
                                    this.siteSvc.selectedLanguageInstant?.id,
                                email,
                            })
                            .pipe(
                                tap((response) => {
                                    this.alert.open(
                                        (response as any).message,
                                        ' ',
                                        {
                                            duration: 10000,
                                            verticalPosition: 'top',
                                        }
                                    );
                                    this.renderer.addClass(
                                        document.getElementsByClassName(
                                            'cdk-global-overlay-wrapper'
                                        )[0],
                                        'alert'
                                    );
                                    this.renderer.addClass(
                                        document.getElementsByClassName(
                                            'mdc-button__label'
                                        )[0],
                                        'babylon-plus'
                                    );
                                    dialogRef.close();
                                }),
                                catchError((err) => {
                                    this.alert.open(err.message, ' ', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                    });
                                    this.renderer.addClass(
                                        document.getElementsByClassName(
                                            'cdk-global-overlay-wrapper'
                                        )[0],
                                        'alert'
                                    );
                                    this.renderer.addClass(
                                        document.getElementsByClassName(
                                            'mdc-button__label'
                                        )[0],
                                        'babylon-plus'
                                    );
                                    this.renderer.addClass(
                                        document.getElementsByClassName(
                                            'mdc-snackbar__surface'
                                        )[0],
                                        'error'
                                    );
                                    return EMPTY;
                                })
                            );
                    })
                )
                .subscribe();

            dialogRef.componentInstance.title = this.newsletterData?.title;
            dialogRef.componentInstance.subtitle =
                this.newsletterData?.subtitle;
            dialogRef.componentInstance.conditions =
                this.newsletterData?.conditions;
            dialogRef.componentInstance.input = this.newsletterData?.input;
            dialogRef.componentInstance.img = this.newsletterData?.img;
            dialogRef.componentInstance.submitForm = submit;
            dialogRef.componentInstance.button = this.newsletterData?.button;
        }
    }

    onOpenGlobalModal(alias?: string) {
        this.layoutSvc.openGlobalModal(this.modalSvc, alias);
    }

    openModalMultMotors(): void {
        const dialogRef = this.dialog.open(
            BabylonModalMultipleMotorsComponent,
            {
                width: this.screenSizer.minMediumTablet() ? '100%' : '100vw',
                height: this.screenSizer.minMediumTablet() ? '100%' : '100vh',
                maxHeight: this.screenSizer.minMediumTablet()
                    ? '100%'
                    : '100vh',
                maxWidth: this.screenSizer.minMediumTablet() ? '100%' : '100vw',
                hasBackdrop: true,
                panelClass: 'newsletter',
            }
        );

        dialogRef.componentInstance.title = this.modalMultipleMotorsData?.title;
        dialogRef.componentInstance.pretitle =
            this.modalMultipleMotorsData?.pretitle;
        dialogRef.componentInstance.logo = this.modalMultipleMotorsData?.logo;
        dialogRef.componentInstance.buttons =
            this.modalMultipleMotorsData?.buttons;

        const openEngineEmitter = new EventEmitter<any>();
        dialogRef.componentInstance.openEngine = openEngineEmitter;

        // Suscribirte al evento para abrir el modal del motor
        openEngineEmitter.subscribe(() => {
            this.openEngineModal();
        });
    }

    sendNewsletterFooter(email?: string): void {
        if (isPlatformBrowser(this.platformId)) {
            if (!email) return;
            this.apiSvc
                .postNewsletterForm({
                    siteId: environment.siteId,
                    consultTypeId: 9,
                    languageId: this.siteSvc.selectedLanguageInstant?.id,
                    email,
                })
                .pipe(
                    tap((response) => {
                        this.alert.open((response as any).message, ' ', {
                            duration: 10000,
                            verticalPosition: 'top',
                        });
                        this.renderer.addClass(
                            document.getElementsByClassName(
                                'cdk-global-overlay-wrapper'
                            )[0],
                            'alert'
                        );
                        this.renderer.addClass(
                            document.getElementsByClassName(
                                'mdc-button__label'
                            )[0],
                            'babylon-plus'
                        );
                    }),
                    catchError((err) => {
                        this.alert.open(err.message, ' ', {
                            duration: 10000,
                            verticalPosition: 'top',
                        });
                        this.renderer.addClass(
                            document.getElementsByClassName(
                                'cdk-global-overlay-wrapper'
                            )[0],
                            'alert'
                        );
                        this.renderer.addClass(
                            document.getElementsByClassName(
                                'mdc-button__label'
                            )[0],
                            'babylon-plus'
                        );
                        this.renderer.addClass(
                            document.getElementsByClassName(
                                'mdc-snackbar__surface'
                            )[0],
                            'error'
                        );
                        return EMPTY;
                    })
                )
                .subscribe();
        }
    }

    private tryAutoOpenNewsletterV2(): void {
        if (!isPlatformBrowser(this.platformId)) return;

        if (sessionStorage.getItem(this.NEWSLETTER_V2_SS_KEY) === '1') return;

        if (!this._newsletterDataV2) return;

        if (this.openedNewsletterV2) return;
        this.openedNewsletterV2 = true;

        this.openNewslettersModal(BabylonNewsletterModalV2Component);
    }

    openNewslettersModal<T>(modal: ComponentType<T>): void {
        if (isPlatformBrowser(this.platformId)) {
            const dialogRef = this.dialog.open(modal, {
                width: this.screenSizer.minMediumTablet() ? '65%' : '95vw',
                height: this.screenSizer.minMediumTablet() ? '80%' : '85vh',
                maxHeight: this.screenSizer.minMediumTablet()
                    ? '714px'
                    : '100vh',
                maxWidth: this.screenSizer.minMediumTablet()
                    ? '1000px'
                    : '100vw',
                hasBackdrop: true,
                panelClass: 'newsletter',
            });
            const submit = new EventEmitter<any>();

            submit
                .pipe(
                    switchMap((email) => {
                        return this.apiSvc
                            .postNewsletterForm({
                                siteId: environment.siteId,
                                consultTypeId: 9,
                                languageId:
                                    this.siteSvc.selectedLanguageInstant?.id,
                                email,
                            })
                            .pipe(
                                tap((response) => {
                                    this.alert.open(
                                        (response as any).message,
                                        ' ',
                                        {
                                            duration: 10000,
                                            verticalPosition: 'top',
                                        }
                                    );
                                    this.renderer.addClass(
                                        document.getElementsByClassName(
                                            'cdk-global-overlay-wrapper'
                                        )[0],
                                        'alert'
                                    );
                                    this.renderer.addClass(
                                        document.getElementsByClassName(
                                            'mdc-button__label'
                                        )[0],
                                        'babylon-plus'
                                    );
                                    dialogRef.close();
                                }),
                                catchError((err) => {
                                    this.alert.open(err.message, ' ', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                    });
                                    this.renderer.addClass(
                                        document.getElementsByClassName(
                                            'cdk-global-overlay-wrapper'
                                        )[0],
                                        'alert'
                                    );
                                    this.renderer.addClass(
                                        document.getElementsByClassName(
                                            'mdc-button__label'
                                        )[0],
                                        'babylon-plus'
                                    );
                                    this.renderer.addClass(
                                        document.getElementsByClassName(
                                            'mdc-snackbar__surface'
                                        )[0],
                                        'error'
                                    );
                                    return EMPTY;
                                })
                            );
                    })
                )
                .subscribe();

            const instance = dialogRef.componentInstance as any;

            const data: any = this.newsletterDataV2 ?? this.newsletterData;

            instance.title = data?.title;
            instance.subtitle = data?.subtitle;
            instance.conditions = data?.conditions;
            instance.input = data?.input;
            instance.img = data?.img;
            instance.button = data?.button;
            instance.buttons = data?.buttons;
            instance.texts = data?.texts;
            instance.multimedia = data?.multimedia;
            instance.submitForm = submit;
        }
    }

    private tryAutoOpenOfferV3(): void {
        if (!isPlatformBrowser(this.platformId)) return;

        if (sessionStorage.getItem(this.OFFER_V3_SS_KEY) === '1') return;

        if (!this._offerPopupV3Data) return;

        const dialogRef = this.dialog.open(BabylonOfferPopupV3Component, {
            width: this.screenSizer.minMediumTablet() ? '65%' : '95vw',
            height: this.screenSizer.minMediumTablet() ? '80%' : '85vh',
            maxWidth: '1000px',
            hasBackdrop: true,
            panelClass: 'offer-popup-v3',
        });

        const instance = dialogRef.componentInstance as any;
        instance.texts = this._offerPopupV3Data.texts;
        instance.multimedia = this._offerPopupV3Data.multimedia;
        instance.offers = this._offerPopupV3Data.offers;

        dialogRef.afterClosed().subscribe(() => {
            sessionStorage.setItem(this.OFFER_V3_SS_KEY, '1');
        });
    }

    getFilteredTexts(props: any) {
        return (props?.texts || []).filter((t: any) => t);
    }

    getFilteredFooterLinks(props: any) {
        return (props?.footerLinks || []).filter((f: any) => f);
    }

    getFilteredSocialMedia(props: any) {
        return (props?.socialMedia || []).filter(
            (s: any) => s && typeof s.name === 'string' && s.name.trim()
        );
    }

    getFilteredButtons(props: any) {
        return (props?.buttons || []).filter((b: any) => b);
    }

    openSelectorModal(componentName: string): void {
        if (componentName.toLocaleLowerCase() === 'modc2imgtxtcta') {
            const dialogRef = this.dialog.open(BabylonModC2ImgTxtCtaComponent, {
                width: '100vw',
                height: '100vh',
                maxWidth: '100vw',
                panelClass: ['full-screen', 'modal-bg-bage'],
                hasBackdrop: true,
            });
            dialogRef.componentInstance.title =
                this.selectorModal?.texts?.title;
            dialogRef.componentInstance.items = this.selectorModal?.items;
        }
    }

    private checkIfComponentExists() {
        const boxSliderElement =
            this.document.querySelector('lis-c3-txt-img-ct');

        this.hasBreadcrumbsTop.set(!!boxSliderElement);
    }
}
